import { Client } from '../types'

export const clients: Client[] = [
  {
    id: '1',
    name: 'Client 1',
    logo: '/images/clients/client-logo-1.png'
  },
  {
    id: '2',
    name: 'Client 2',
    logo: '/images/clients/client-logo-2.png'
  },
  {
    id: '3',
    name: 'Client 3',
    logo: '/images/clients/client-logo-3.png'
  },
  {
    id: '4',
    name: 'Client 4',
    logo: '/images/clients/client-logo-4.png'
  },
  {
    id: '5',
    name: 'Client 5',
    logo: '/images/clients/client-logo-5.png'
  },
  {
    id: '6',
    name: 'Client 6',
    logo: '/images/clients/client-logo-6.png'
  },
  {
    id: '7',
    name: 'Client 7',
    logo: '/images/clients/client-logo-7.png'
  },
  {
    id: '8',
    name: 'Client 8',
    logo: '/images/clients/client-logo-8.png'
  },
  {
    id: '9',
    name: 'Client 9',
    logo: '/images/clients/client-logo-9.jpg'
  },
  {
    id: '10',
    name: 'Client 10',
    logo: '/images/clients/client-logo-10.jpg'
  },
  {
    id: '11',
    name: 'Client 11',
    logo: '/images/clients/client-logo-11.jpg'
  },
  {
    id: '12',
    name: 'Client 12',
    logo: '/images/clients/client-logo-12.png'
  },
  {
    id: '13',
    name: 'Client 13',
    logo: '/images/clients/client-logo-13.png'
  },
  {
    id: '14',
    name: 'Client 14',
    logo: '/images/clients/client-logo-14.png'
  },
  {
    id: '15',
    name: 'Client 15',
    logo: '/images/clients/client-logo-15.png'
  }
]
